/** Persistent cookie-backed identity. Never persist session tokens in browser storage. */
import React, { createContext, useContext } from "react";
import { useSessionAuth } from "./useSessionAuth";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const auth = useSessionAuth();
  return (
    <AuthContext.Provider value={auth}>
      {auth.authError && <div role="status" className="border-b border-[var(--hairline)] bg-[var(--paper)] text-[var(--ink)] px-4 py-3 flex flex-wrap items-center justify-center gap-3 text-sm" data-testid="session-connection-notice">
        <span data-testid="session-connection-message">{auth.authError.message}</span>
        <button type="button" onClick={() => auth.authError.action === "logout" ? auth.logout() : auth.checkAuth({ force: true })} className="underline underline-offset-4 min-h-10 px-2 hover:text-[var(--crimson)] transition-colors" data-testid="session-retry-button">{auth.authError.action === "logout" ? "Retry sign-out" : "Retry"}</button>
      </div>}
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
}